<div class="page-body">
    <h1>Техническая поддержка</h1>
    <h2>Часто задаваемые вопросы:</h2>
    <ol>
        <li class="list-title">
            Какая конфигурация компьютера достаточна для комфортной работы с Виртуальными
            лабораториями?
        </li>
        <p>
            Чтобы Виртуальные лаборатории заработали, вам необходимо использовать компьютер, со
            следующими параметрами, не хуже:
        </p>
        <ul>
            <li>Процессор: Intel серии Ivy Bridge / AMD серии Bulldozer и новее;</li>
            <li>Оперативная память: 4 ГБ или больше;</li>
            <li>
                Видеокарта: встроенная: Intel HD Graphics 5000 / Intel Iris и новее; дискретная:
                GeForce 400 серии или новее / Radeon HD 7000 серии или новее;
            </li>
            <li>
                Разрешение экрана: 1920×1080 / 1920×1200 и больше (4K и Retina экраны требуют
                видеокарты большей мощности для комфортной работы);
            </li>
            <li>
                Поддерживаемые браузеры: Chrome, Яндекс.Браузер, Opera 44+, Firefox 51+, Edge 79+,
                Safari 15+;
            </li>
            <li>
                Поддерживаемые операционные системы: Microsoft Windows 7 (х64 версии) или выше с
                поддержкой драйверов WebGL 2.0, MacOS X «Snow Leopard» 10.6 или выше с поддержкой
                драйверов WebGL 2.0, Linux или Debian с поддержкой драйверов WebGL 2.0.
            </li>
        </ul>
        <p>
            Узнать поддерживает ли именно ваше устройство WebGL 2.0 вы можете по ссылке –
            <a href="https://webglreport.com/?v=2">https://webglreport.com/?v=2</a>
        </p>
        <li class="list-title">
            Что делать, если Виртуальные лаборатории не загружаются, зависают при запуске или
            некорректно отображаются во время работы?
        </li>
        <p>
            Некорректное отображение или зависание при запуске связано с тем, что для работы
            Виртуальных лабораторий необходимо, чтобы ваш web-браузер поддерживал стандарт WebGL
            2.0. Быстро проверить поддержку WebGL 2.0 в вашем web-браузере можно по ссылке –
            <a href="https://webglreport.com/?v=2">https://webglreport.com/?v=2</a>
        </p>
        <li class="list-title">
            Что делать, если вы увидели на экране надпись «Your browser does not support any of the
            required graphics API for this content»?
        </li>
        <p>Существует несколько распространенных сценариев, вызывающих данную проблему:</p>
        <ul>
            <li>
                Версия браузера не поддерживает WebGL. Старые версии браузеров не поддерживают
                технологию WebGL. Если у вас возникла проблема с очень устаревшей версией вашего
                браузера, вам необходимо выполнить обновление до версии, поддерживающей WebGL.
            </li>
            <li>
                В вашем браузере не включено аппаратное ускорение. Хотя WebGL не требует аппаратного
                ускорения, мы обнаружили множество сообщений о том, что технология WebGL не работает
                должным образом. Известно, что браузер Chrome ложно сообщает, что WebGL не
                поддерживается, когда аппаратное ускорение отключено. В этом случае решение состоит
                в том, чтобы зайти в настройки вашего браузера и включить аппаратное ускорение.
            </li>
            <li>
                Полностью устаревший графический драйвер. В этом случае обновите графический драйвер
                до последней версии автоматически (с помощью диспетчера устройств) или вручную (с
                помощью ПО от производителя вашего оборудования).
            </li>
            <li>
                Windows XP не поддерживает WebGL. Если вы всё ещё используете Windows XP, вам,
                потребуется перейти на новую версию Windows 10, чтобы использовать технологию WebGL.
            </li>
            <p>
                Быстро проверить поддержку WebGL 2.0 в вашем web-браузере можно по ссылке –
                <a href="https://webglreport.com/?v=2">https://webglreport.com/?v=2</a>
            </p>
        </ul>
        <li class="list-title">
            Что делать, если вы увидели на экране надпись «Your browser does not support graphics
            API "WebGL 2.0" which is required for this content.»?
        </li>
        <p>
            Увы, проблема в вашем компьютере. Чтобы Виртуальная лаборатория заработала у вас, вам
            необходимо использовать компьютер, со следующими параметрами, не хуже:
        </p>
        <ul>
            <li>Процессор: Intel серии Ivy Bridge / AMD серии Bulldozer и новее;</li>
            <li>Оперативная память: 4 ГБ или больше;</li>
            <li>
                Видеокарта: встроенная: Intel HD Graphics 5000 / Intel Iris и новее; дискретная:
                GeForce 400 серии или новее / Radeon HD 7000 серии или новее;
            </li>
            <li>
                Разрешение экрана: 1920×1080 / 1920×1200 и больше (4K и Retina экраны требуют
                видеокарты большей мощности для комфортной работы);
            </li>
            <li>
                Поддерживаемые браузеры: Chrome, Яндекс.Браузер, Opera 44+, Firefox 51+, Edge 79+,
                Safari 15+;
            </li>
            <li>
                Поддерживаемые операционные системы: Microsoft Windows 7 (х64 версии) или выше с
                поддержкой драйверов WebGL 2.0, MacOS X «Snow Leopard» 10.6 или выше с поддержкой
                драйверов WebGL 2.0, Linux или Debian с поддержкой драйверов WebGL 2.0.
            </li>
        </ul>
        <p>
            Узнать поддерживает ли именно ваше устройство WebGL 2.0 вы можете по ссылке –
            <a href="https://webglreport.com/?v=2">https://webglreport.com/?v=2</a>
        </p>
    </ol>
    <h3>Вы не нашли ответа на свой вопрос?</h3>
    <p>
        Свяжитесь с нами любым удобным способом. Мы ответим на ваши вопросы. Техническую поддержку
        ПО обеспечивает: Топольцева Дарья Владимировна, Руководитель технической поддержки, тел.: +7
        (495) 178-03-21, e-mail: supportviz&#64;answer-42.ru
    </p>
</div>
